import ReturningUsersContext from '../../contexts/ReturningUsers.js';
import LastViewedVehicles from '../../storage/autoV10/LastViewedVehicles.js';
import SearchQuery from '../../storage/autoV10/SearchQuery.js';
import EnquiriesSent from '../../storage/autoV10/EnquiriesSent.js';
import Builder from './Builder.js';
import SessionCounter from '../../storage/autoV10/SessionCounter.js';

export default class ReturningUsers extends Builder {
  constructor() {
    super();
    if (SessionCounter.get() > 1) {
      this._setupContext();
    }
  }

  _setupContext() {
    this.context = new ReturningUsersContext();
    this.context.setData(LastViewedVehicles.getNumbers(), SearchQuery.get(), EnquiriesSent.get());
  }
}
